<style>
    @import 'index.less';
</style>

<template>
    <div class="all">
        <Spin v-if="pageLoading" fix size="large"></Spin>
        <!--单位详情-->
        <div class="_companyinfo">
            <div class="head">
                <span class="title">单位详情</span>
                <!--这块暂时屏蔽，以后配合需求放开-->
                <span class="edit" v-if="editAuth===true">
                    <router-link :to="{ name : 'editcompany'}" v-if="type==='2'">
                        <Icon type="edit"></Icon>
                        编辑
                    </router-link>
                    <router-link :to="{ name : 'edit-other-company'}" v-else>
                        <Icon type="edit"></Icon>
                        编辑
                    </router-link>
                </span>
            </div>
            <div class="baseinfo">
                <template  v-for="vo in otherData">
                    <label class="item-label" v-if="vo.type === 'visible'">
                        <span class="label-title">
                            {{vo.title}}：
                        </span>
                        <span v-html="(vo.value +' '+ (vo.unit&&vo.value ? vo.unit :'') )">
                            <!--{{vo.value}} {{vo.unit?vo.unit:''}}-->
                        </span>
                    </label>
                    <div class="logo" v-if="vo.type==='img'">
                        <img :src="vo.value" />
                    </div>
                </template>
            </div>
            <span style="clear: both"></span>
        </div>
        <pictures></pictures>
    </div>
</template>

<script>
    import baseAuthEnum from "@/staticData/baseAuthEnum";
    import setting from "./business/Setting"
    import pictures from "./business/Pictures"
    import utils from "@/utils";
    import $api from "@/service/index"

    export default {
        components:{
            setting,
            pictures
        },
        data(){
            return {
                pageLoading : true, //页面加载状态
                baseData : [],      //单位基本信息
                companyId: "0",     //单位id
                type : "0",         //单位类型
                otherData:[],       //除了园区端的单位基本信息
                editAuth : false,   //编辑单位权限
            }
        },
        mounted(){
            this.getAuthList();
            this.getCompanyBaseInfo();
        },
        methods : {
            //查询权限
            getAuthList(){
                this.editAuth = utils.judgeAuth([baseAuthEnum.EDIT_COMPANY_INFO],1);
            },
            //获取公司基本信息
            getCompanyBaseInfo(){
                let _self = this;
                this.pageLoading = true;
                $api.getCompanyInfo().then(data => {
                    _self.pageLoading = false;
                    _self.baseData = _self.fixBrTab(data.data);
                    _self.companyId = data.id;
                    _self.type = data.type;
                    if(data.type !== "2" && data.type !== 2){
                        _self.otherData = _self.baseData.list;
                    }
                });
            },
            //调整一下数据格式\n\r转br
            fixBrTab(data){
                for (let k = 0 ; k < data.list.length;k++){
                    if(data.list[k].name === "intro"){
                        data.list[k].value = this.fixStr(data.list[k].value);
                    }
                    if(data.list[k].name === "phone"){
                        data.list[k].value = this.filterPhone(data.list[k].value);
                    }
                }
                return data;
            },
            /**
             * \n\r转br,\t转&nbsp;
             * @param {string} str 待调整的字符串
             * @returns {string}
             */
            fixStr(str=""){
                //替换所有的换行符
                str = str.replace(/\r\n/g,"<br>");
                str = str.replace(/\n/g,"<br>");
                //替换所有的空格（中文空格、英文空格都会被替换）
                str = str.replace(/\s/g,"&nbsp;");
                return str;
            },
            filterPhone(phone) {
                if (!phone) {
                    return '';
                }
                if (phone.charAt(phone.length - 1) == '-') {
                    return phone.substr(0, phone.length - 1);
                } else {
                    return phone;
                }
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/pages/company/baseinfo/Index.vue